import { HTMLMotionProps } from 'framer-motion';
import { theme } from '../../../theme/theme';

/**
 * Presence animation to be used with motion's `AnimatePresence` component.
 *
 * @param opacity initial and exit opacity value
 * @param slide horizontal slide on animation toggle
 * @param pop vertical slide on animation toggle
 * @param rotate rotation on animation toggle
 * @param delay delay seconds for animation enter and exit
 * @param opposite set initial and exit animations to have opposite directions
 * @param duration animation duration, can be one or two values (for enter and exit)
 */
const presence = (
    { opacity = 0, slide = 0, pop = 0, rotate = 0, delay = 0 },
    opposite = false,
    duration: number | [number, number] = [theme.transitions.default, theme.transitions.fast],
): HTMLMotionProps<'div'> => {
    const [enter, exit] = duration instanceof Array ? duration : [duration, duration];
    const dir = opposite ? -1 : 1;
    return {
        initial: { opacity, x: slide, y: pop, rotate: rotate },
        animate: { opacity: 1, x: 0, y: 0, rotate: 0, transition: { duration: enter, delay } },
        exit: { opacity, x: slide * dir, y: pop * dir, rotate: rotate * dir, transition: { duration: exit, delay } },
    };
};

export const motions = { presence };
